<template>
    <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
    </Form>
</template>

<script>
import { Form } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { initForm, isLoading, onClickModalOk } from "./not-approve-request.logic";

export default defineComponent({
    components: {
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder"))
    },
    props: {
        viewOnly: { default: false },
        form: {}
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        return {
            props,
            data,
            refs,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
